import React from 'react';

import { INTERNAL_SEARCH_TOOL_CALL_NAME } from '../ToolCall/InternalSearchToolCall/consts';

import { InternalToolCallResults } from './ToolResult/InternalToolCallResults';
import { useMessageToolCallResults } from './hooks';

import styles from './ToolCallsResults.module.scss';

export const ToolResultRenderer: React.FC = () => {
    const resultsToRender = useMessageToolCallResults();

    return (
        <div className={styles.toolCallResults}>
            {resultsToRender.map(({ functionName, data }) => {
                // use `switch` when we start to support more `tools` in the future
                // when adding support for the other tool type, update the result count function `countResults`
                return functionName === INTERNAL_SEARCH_TOOL_CALL_NAME ? (
                    <InternalToolCallResults
                        key={INTERNAL_SEARCH_TOOL_CALL_NAME}
                        functionName={functionName}
                        data={data}
                    />
                ) : null;
            })}
        </div>
    );
};
